import { useCallback, useEffect, useRef, useState } from "react";
import { getUserDetailsById, updateUser } from "../../services/AllServices";
import {showMessage } from "../../utils/helpers";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import { UpdateUserValidation } from "../../pages/UserManagement/Validations";

const useUserManagementViewViewController = () => {
    const [editState, setEditState] = useState(true);
    const [generatedPassword, setGeneratedPassword] = useState("");
    const [editEmailState,setEditEmailState] = useState(true)
    const [userData, setUserData] = useState({});
    const { id } = useParams();
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const { state = {} } = useLocation();
    const renderAfterCalled = useRef(false);
    const [loading, setLoading] = useState(false);

    const fetchData = useCallback(async () => {
      setLoading(true);
      try {
        const response = await getUserDetailsById(id);
        setUserData(response);
      } catch (error) {
        showMessage("error", error?.data.message || "Something went wrong");
      }
      setLoading(false);
    }, [id]);
  
    useEffect(() => {
      if (!renderAfterCalled.current) {
        fetchData();
      }
      renderAfterCalled.current = true;
    }, [fetchData]);
  
    const { setFieldValue, values, handleSubmit, handleChange } = useFormik({
      initialValues: {
        role: "",
        updated_email: ""
      },
      // validationSchema: UpdateUserValidation,
      onSubmit: async () => {
        setLoading(true);
        try {
          let sendBody;
          if (state?.view) {
            sendBody = {};
            if (values.role !== "") {
              sendBody.role = values.role;
            }
            if (values.updated_email !== "") {
              sendBody.updated_email = values.updated_email;
            }
            await updateUser(id, sendBody);
            setEditState(true);
            showMessage("success", "User Updated Successfully");
          } else {
            sendBody = {
              reset_password: true,
            };
            let responseData = await updateUser(id, sendBody);
            setGeneratedPassword(responseData?.password);
            setShowModal(true);
          }
          fetchData();
        } catch (error) {
          setShowModal(false);
          showMessage("error", error?.data.message || "Something went wrong");
        }
        setLoading(false);
      },
    });
  const goBack = () => {
    navigate('/user-management')
  };
    const handleSelectedEmployee = (e) => {
      if(e)
      {
      setFieldValue("role", e?.value);
      }
      else{
        setFieldValue("role", "");
      }
    };
  
  
    return {
        goBack,
        handleSubmit,
        handleSelectedEmployee,
        values,
        editState,
        setEditState,
        showModal,
        setShowModal,
        generatedPassword,
        userData,
        state,
        loading,
        handleChange,
        editEmailState,
        setEditEmailState,
    }
}
export default useUserManagementViewViewController;